interface AlertProps {
    color?: 'Default' | 'White';
}

const ALERT_COLOR_SCHEMES = {
    Default: '#6B6B6B', 
    White: '#FFFFFF' 
};

export const Alert: React.FC<AlertProps> = ({ color: colorScheme = 'Default' }) => {
    const color = ALERT_COLOR_SCHEMES[colorScheme];

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_249_50696)">
                <path 
                    d="M16.667 14.166H18.3337V15.8327H1.66699V14.166H3.33366V8.33268C3.33366 6.56457 4.03604 4.86888 5.28628 3.61864C6.53652 2.36839 8.23222 1.66602 10.0003 1.66602C11.7684 1.66602 13.4641 2.36839 14.7144 3.61864C15.9646 4.86888 16.667 6.56457 16.667 8.33268V14.166ZM15.0003 14.166V8.33268C15.0003 7.0066 14.4735 5.73483 13.5359 4.79715C12.5982 3.85947 11.3264 3.33268 10.0003 3.33268C8.67424 3.33268 7.40247 3.85947 6.46479 4.79715C5.52711 5.73483 5.00033 7.0066 5.00033 8.33268V14.166H15.0003ZM7.50033 17.4993H12.5003V19.166H7.50033V17.4993Z"
                    fill={color} 
                />
            </g>
            <defs>
                <clipPath id="clip0_249_50696">
                    <rect width="20" height="20" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};
